<template>
  <div class="login_box">
    <div class="login_l">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="login_form" auto-complete="on" label-position="top" hide-required-asterisk>
        <img src="@/assets/images/logo.png" class="login_logo">
        <div class="login_title">登录您的账户</div>
        <el-form-item prop="mobile">
          <template slot="label"><i class="iconfont icon-yonghu"></i>账号</template>
          <el-input v-model="ruleForm.mobile" autocomplete="off" tabindex="1"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <template slot="label"><i class="iconfont icon-mima"></i>密码</template>
          <el-input type="password" v-model="ruleForm.password" autocomplete="new-password" tabindex="2" @keyup.enter.native="handleLogin" show-password></el-input>
        </el-form-item>
        <router-link tag="div" to="/forgetPassword" class="login_forget">忘记密码？</router-link>
        <el-button :loading="loading" class="login_btn"
          @click.native.prevent="handleLogin">登录</el-button>
          <router-link tag="div" to="/register" class="login_to">去注册</router-link>
      </el-form>
    </div>
    <img src="@/assets/images/login-bg.png" class="login_r">
  </div>
</template>
<script>
import {userLogin, userRefreshToken} from '@/api/user'
export default {
  name: "login",
  data () {
   return {
    ruleForm: {
      mobile: '',
      password: ''
    },
    rules: {
      mobile: [{ required: true, trigger: 'blur', message: '请填写用户名' }],
      password: [{ required: true, trigger: 'blur', message: '请填写用户密码' }]
    },
    loading: false,

    // 使用插件登录
    isExtendLogin: false
   }
  },
  created() {
    if(this.$route.query && this.$route.query.client_id == 'chrome_extends') {
      this.isExtendLogin = true
      if(this.$store.state.token || localStorage.getItem("37aiToken")) {
        userRefreshToken({token: this.$store.state.token}).then(async res => {
          this.$store.commit('setToken', res.data.token)
          await this.$store.dispatch("USER_INFO");
          res.data.user_info = {nickname: this.$store.state.userInfo.nickname}
          window.postMessage({type: "LOGIN_SUCCESS",data: res.data})
          setTimeout(() => {
            window.close();
          }, 300);
        })
      }
    }
  },
  methods:{
    handleLogin() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          userLogin(this.ruleForm).then(async res => {
            await this.$store.dispatch("USER_LOGIN", res.data);
            await this.$store.dispatch("USER_INFO");
            if(this.isExtendLogin) {
              window.postMessage({type: "LOGIN_SUCCESS",data: res.data})
              setTimeout(() => {
                window.close();
              }, 300);
            }else {
              this.$router.push('/')
            }
          }).finally(() => {
            this.isloading = false
          })
        }
      })
    }
    
  }
}
</script>
<style lang="scss" scoped>
.login_box {
  display: flex;
  justify-content: space-between;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(91.05deg, #F2F8FA 0%, #FFFFFF 21.78%, #FAFAFA 52.35%, #E3EFFF 72.92%, #DCE7FC 100%);
  .login_l {
    display: grid;
    place-items: center;
    width: 50%;
    height: 100%;
    overflow: auto;
    // background: #FFFFFF;
    &::-webkit-scrollbar {
      display: none;
    }
    .login_logo {
      width: 50%;
      margin-bottom: 36px;
    }
    .login_title {
      font-size: 20px;
      margin-bottom: 72px;
    }
    .login_form {
      margin: auto;
      width: 56%;
      /deep/ .el-form-item {
        border: 1px solid #E0E0E0;
        border-radius: 12px;
        padding: 16px;
       .el-form-item__label {
          font-size: 12px;
          color: #595959;
          font-weight: 400;
          line-height: 1;
          i {
            margin-right: 8px;
            vertical-align: text-bottom;
          }
          img {
            width: 14px;
            margin-right: 8px;
            vertical-align: middle;
          }
        }
        .el-form-item__content{
          line-height: 32px;
          .el-input  {
            font-size: 24px;
            .el-input__inner {
              background: transparent;
              border: none;
              height: 32px;
              line-height: 32px;
              color: #000000;
              padding-left: 0;
            }
            .el-input__inner:-webkit-autofill {
              transition: background-color 5000s ease-in-out 0s;
              // -webkit-text-fill-color: #fff !important;
            }
            .el-input__inner:-webkit-autofill:focus {
              // -webkit-text-fill-color: #fff !important;
            }
          }
          .el-form-item__error {
            top: 148%;
          }
        }
      } 
    }
    .login_btn {
      border-radius: 8px;
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      height: 64px;
      color: #F7F8FA;
      font-size: 20px;
      width: 100%;
      border: none;
      margin-top: 24px;
    }
    .login_to {
      margin-top: 12px;
      text-align: center;
      cursor: pointer;
      color: #737373;
    }
    .login_forget {
      color: #737373;
      cursor: pointer;
      text-align: right;
      margin-left: auto;
      width: fit-content;
    }
  }
  .login_r {
    width: 50%;
    object-fit: cover;
  }
}
</style>